import { defineElement, FC, onDidLoad } from '@atomify/hooks';
import { h } from '@atomify/jsx';
import { useStore } from '@atomify/kit';
import { ButtonA } from '@source/components/atoms/button/button';
import { CompareState, compareStore, getCompareState } from '@source/store/compare';
import { useTranslate } from '@source/utilities/hooks';

export const CompareOpenButton: FC = ({ element }) => {
    const [, subscribe] = useStore<CompareState>(compareStore);

    onDidLoad(render);
    subscribe(render);

    function render() {
        const { constructionNumberIds } = getCompareState();
        const total = constructionNumberIds.length;

        element.innerHTML = '';

        if (total) {
            element.append(
                <div class="c-compare-open-button">
                    <ButtonA
                        url={window.__ENVIRONMENT_DETAILS__.compareUrl}
                        width="full-width"
                        variant="primary"
                        attr={{ ['js-hook-compare-button-link']: '' }}>
                        {useTranslate('Compare.CompareHouses')}

                        <span class="compare-open-button__total">{total ? total : ''}</span>
                    </ButtonA>
                </div>,
            );
        }
    }
};

defineElement('compare-open-button', CompareOpenButton);
